import React from 'react';
import Grid from '@material-ui/core/Grid';

import { InfoCharts } from 'features/dashboard/components/InfoCharts';
import { OrderSummary } from 'features/dashboard/components/OrderSummary';
import { SendGiftButtons } from 'features/dashboard/components/SendGiftButtons';
import { TotalInfo } from 'features/dashboard/components/TotalInfo';

import { useStyles } from './styles';
import i18n from 'locales/i18n';
import useUser from 'features/user/hooks/useUser';
import { Redirect } from 'react-router-dom';
import { getStartedPaths } from 'features/get-started/routes/paths';

export const Dashboard = () => {
  const { user } = useUser();

  const direction = i18n.dir();

  const classes = useStyles({ direction });

  return user?.show_started_tips ? (
    <Redirect to={getStartedPaths.static.firstStep} />
  ) : (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item className={classes.sendGiftButtons}>
          <SendGiftButtons />
        </Grid>
        <Grid item className={classes.totalInfo}>
          <TotalInfo />
        </Grid>
      </Grid>
      <InfoCharts />
      <OrderSummary />
    </>
  );
};
